import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TowersService } from '../towers.service';
import { SessionService } from '@core/services/session.service';
import {
  TowersModeVariants,
  TowersStart,
} from '../interfaces/towers.interface';
import { ClipboardService } from '@core/services/clipboard.service';
import { CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GameIconComponent } from '../../../core/components/game-icon/game-icon.component';
import { InputOptionsComponent } from '../../../core/components/input-options/input-options.component';
import { BalanceIconComponent } from '../../../core/components/balance-icon/balance-icon.component';
import { FairnessButtonComponent } from '../../../core/components/fairness-button/fairness-button.component';
import { fadeInAnimation } from '@core/utils/animations.util';
import { OldSliderComponent } from '@core/components/old-slider/old-slider.component';

@Component({
  selector: 'app-towers-bet-section',
  templateUrl: './towers-bet-section.component.html',
  styleUrls: ['./towers-bet-section.component.scss'],
  imports: [
    CurrencyPipe,
    FormsModule,
    GameIconComponent,
    InputOptionsComponent,
    BalanceIconComponent,
    FairnessButtonComponent,
    OldSliderComponent,
  ],
  animations: [fadeInAnimation],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'box-black-third rounded-6',
  },
})
export class TowersBetSectionComponent {
  betInputOptions = [
    {
      label: '1/2',
      fn: () => this.setBet('half'),
    },
    {
      label: '2x',
      fn: () => this.setBet('double'),
    },
    {
      label: 'Max',
      fn: () => this.setBet('max'),
    },
  ];

  betButtons = [
    {
      label: '+1',
      fn: () => this.setBet(1),
    },
    {
      label: '+10',
      fn: () => this.setBet(10),
    },
    {
      label: '+25',
      fn: () => this.setBet(25),
    },
    {
      label: '+100',
      fn: () => this.setBet(100),
    },
  ];

  constructor(
    public sessionService: SessionService,
    public towersService: TowersService,
    public clipboardService: ClipboardService
  ) {}

  setBet(bet: string | number) {
    this.towersService.amount.update((prev) => {
      let value: number = prev;

      if (typeof bet === 'number') {
        value = prev + bet;
      } else {
        switch (bet) {
          case 'max':
            value = Math.min(
              this.sessionService.currentBalance() ?? 0,
              this.towersService.MAX_AMOUNT
            );
            break;

          case 'half':
            value = Math.max(prev / 2, this.towersService.MIN_AMOUNT);
            break;

          case 'double':
            value = Math.min(prev * 2, this.towersService.MAX_AMOUNT);
            break;
        }
      }

      value = Math.min(value, this.towersService.MAX_AMOUNT);
      value = Math.max(value, this.towersService.MIN_AMOUNT);

      return Math.round(value * 100) / 100;
    });
  }

  setMode(mode: TowersModeVariants) {
    this.towersService.clearArea();

    if (mode === 'high') {
      this.towersService.mode.set({
        modeName: 'high',
        tiles: 3,
        death_tiles: 2,
      });
      this.towersService.items.set(this.towersService.getItemsByMode(3));
    }

    if (mode === 'medium') {
      this.towersService.mode.set({
        modeName: 'medium',
        tiles: 3,
        death_tiles: 1,
      });
      this.towersService.items.set(this.towersService.getItemsByMode(3));
    }

    if (mode === 'low') {
      this.towersService.mode.set({
        modeName: 'low',
        tiles: 4,
        death_tiles: 1,
      });
      this.towersService.items.set(this.towersService.getItemsByMode(4));
    }
  }

  handleStartTowers() {
    this.towersService.clearArea();

    const sendedData: TowersStart = {
      tiles: this.towersService.mode().tiles,
      death_tiles: this.towersService.mode().death_tiles,
      amount: this.towersService.amount(),
    };
    this.towersService.startTowers(sendedData);
  }
}
